import { Trans } from 'react-i18next';

import { StudentOnboardingPageTranslations } from '../../../../i18n';

interface TranslatedTextProps {
  i18nKey: keyof typeof StudentOnboardingPageTranslations;
  values?: Record<string, string>;
}

export const TranslatedText = ({ i18nKey, values }: TranslatedTextProps) => {
  return (
    <span>
      <Trans
        i18nKey={`StudentOnboardingPageTranslations:${i18nKey}`}
        components={{
          strong: <strong />
        }}
        values={values}
      />
    </span>
  );
};
